export default __webpack_public_path__ + "components/weather-icon/static/nightclear-41f13f637764ad873f8be5c78537e743.png";